import { fromJS } from 'immutable';

import { UPDATE_SECTION_VISIBILITY } from './types';

export * from './actions';

const initialState = fromJS({
  network: {
    loading: false,
    error: false,
  },
  byId: {},
});

const updateSectionVisibility = (state, action) =>
  state.setIn(['byId', action.clientId, action.sectionIdentifier], action.visibility);

const monitorShareableReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SECTION_VISIBILITY:
      return updateSectionVisibility(state, action);

    default:
      return state;
  }
};

export default monitorShareableReportReducer;
